import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">S</span></div>
                                            <span className=" circlediscp verticalContentPadding ">
    <p><span className="brownbold brown">Specific </span> or Significant or Stretching</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">M</span></div>
                                            <span className=" circlediscp verticalContentPadding ">
    <p><span className="brownbold brown ">Measurable </span>  or Meaningful or Motivational</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">A</span></div>
                                            <span className=" circlediscp verticalContentPadding ">
    <p><span className="brownbold brown">Agreed </span>  or Attainable or Acceptable</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">R</span></div>
                                            <span className=" circlediscp verticalContentPadding ">
    <p><span className="brownbold brown">Realistic </span>or Relevant or Rewarding</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">T</span></div>
                                            <span className=" circlediscp verticalContentPadding ">
    <p><span className="brownbold brown">Timed </span>or Timely or Tangible</p></span>
                                            <br/>
                                            <p><span className="brownbold brown">Specific</span> <span
                                                className="subtiltereg ">or Significant or Stretching –</span> It
                                                is important that the goal is well defined and clearly
                                                articulated to ensure that you know exactly what you want to
                                                achieve. It will be easy to know
                                                when you have achieved your goal if you know exactly what it
                                                is in the first place!</p>
                                            <p>For example, working towards a target such as ‘£10,000 a day’
                                                is more specific than a goal of
                                                having to ‘do well at selling today’. This will help you and
                                                those around you to have a clear view of
                                                the plan and its progress.</p>
                                            <p>It is also important for the goal to be specifically tailored
                                                to the individual and the situation. If, for
                                                example, it is the week before Christmas and you are putting
                                                in extra shifts, it is likely that the
                                                target would need to be adjusted to suit this specific
                                                situation.</p>

                                            <p><span className="brownbold brown">Measurable</span> <span
                                                className="subtiltereg ">or Meaningful or Motivational –</span> Once
                                                you have your specific target and know
                                                exactly what is expected, it is important to consider how
                                                your performance will be measured
                                                against this target; it is not always as straightforward as
                                                just assigning monetary values!</p>
                                            <p>For example, if your target is to become proficient at giving
                                                presentations, this may not be as easy
                                                to measure as whether you take £10,000 or not. Consider ways
                                                in which your outcomes can be
                                                measured – maybe feedback from those you are presenting to
                                                or a more quantitative measure,
                                                such as how many questions you garner at the end of the
                                                presentation. In order to make the
                                                measure valid, make sure to have planned it in advance to
                                                avoid the pitfall of choosing a favourable
                                                measure after you’ve taken the action.</p>

                                            <p><span className="brownbold brown">Agreed</span> <span
                                                className="subtiltereg ">or Attainable or Acceptable –</span> This
                                                refers to agreement of what the target will be,
                                                between manager and managee. This is an important element of
                                                the process, because if you
                                                have not agreed what the target will be you may be working
                                                towards different aims!</p>
                                            <p>For example, if a manager gets buy-in from the other party at
                                                the time of setting the target, it is
                                                more likely that the managee will feel that they have some
                                                ownership over it as they have had a
                                                say in what is to be achieved. They are then more likely to
                                                be motivated to achieve the goal.
                                                Where goals are decided by one party and rejected by the
                                                other it may be less likely that they are
                                                achieved.</p>

                                            <p><span className="brownbold brown">Realistic</span> <span
                                                className="subtiltereg ">or Relevant or Rewarding – </span> This
                                                seems obvious, as there is no point in setting an
                                                unattainable goal. People generally find that the hardest
                                                part is to strike the right balance. A
                                                difficult, yet attainable, goal will lead to higher
                                                performance than will an easily attainable goal or,
                                                indeed, an impossible one. If a goal is too easy, an
                                                individual may lower their effort levels and so
                                                the motivation to complete the task will decrease. On the
                                                other hand, if the goal is seen as
                                                impossible there may be little motivation to work towards it
                                                as there is no point.</p>
                                            <p>For example, it is important to work with an
                                                employer/employee to agree what is realistic for you
                                                and your situation. If there is a 200-page report to be
                                                written by the end of the week and the
                                                individual is out with clients for three days and in
                                                meetings for one day, it is unrealistic to expect
                                                that they will have time to complete it to a high standard
                                                in the timeframe required.</p>

                                            <p><span className="brownbold brown">Timed</span> <span
                                                className="subtiltereg ">or Timely or Tangible –</span> It
                                                is most productive when setting targets to work to specific
                                                timescales. It is often useful to provide a deadline to work
                                                to in order to be clear about when the
                                                target needs to be achieved. This also provides you with a
                                                point in time to work towards, which is
                                                particularly useful if the outcome of a project is otherwise
                                                ambiguous.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}